import { render, staticRenderFns } from "./AdminCreateQuestionsFiles.vue?vue&type=template&id=4bb4102a&scoped=true"
import script from "./AdminCreateQuestionsFiles.vue?vue&type=script&lang=js"
export * from "./AdminCreateQuestionsFiles.vue?vue&type=script&lang=js"
import style0 from "./AdminCreateQuestionsFiles.vue?vue&type=style&index=0&id=4bb4102a&lang=css"
import style1 from "./AdminCreateQuestionsFiles.vue?vue&type=style&index=1&id=4bb4102a&scoped=true&lang=css"
import style2 from "./AdminCreateQuestionsFiles.vue?vue&type=style&index=2&id=4bb4102a&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb4102a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bb4102a')) {
      api.createRecord('4bb4102a', component.options)
    } else {
      api.reload('4bb4102a', component.options)
    }
    module.hot.accept("./AdminCreateQuestionsFiles.vue?vue&type=template&id=4bb4102a&scoped=true", function () {
      api.rerender('4bb4102a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminCreateQuestionsFiles.vue"
export default component.exports